import React from 'react';
import PropTypes from 'prop-types';

const ToggleDrawerButton = ({ toggleFiltersDrawer, children, ariaExpanded, ariaControls, ariaDisabled, id }) => (
  <button
    aria-controls={ariaControls}
    aria-disabled={ariaDisabled}
    aria-expanded={ariaExpanded}
    className="labels-toggle-drawer-button"
    id={id}
    onClick={() => {
      toggleFiltersDrawer('labels-drawer');
    }}
    type="button"
  >
    <div className="carrots-container">
      <span className="bff-caret-down icon" />
      <span className="bff-caret-down icon" />
    </div>
    {children}
  </button>
);

ToggleDrawerButton.propTypes = {
  toggleFiltersDrawer: PropTypes.func.isRequired,
  ariaExpanded: PropTypes.bool.isRequired,
  ariaControls: PropTypes.string.isRequired,
  ariaDisabled: PropTypes.bool,
  id: PropTypes.string.isRequired,
};

ToggleDrawerButton.defaultProps = {
  ariaDisabled: false,
};

export default ToggleDrawerButton;
